import { useDispatch, useSelector } from 'react-redux';
import { toggleFormWidget } from '@/redux/actions';
import { SideFloatingButtonWrapper } from './SideFloatingButton.styled';
import { transformWidgetProps } from '@/components/WidgetMaker/utils/common';
import { getStyleForProps } from '@/components/DesignSystem/ModernTheme/utils/getStylesConfig';
import { useEffect, useState } from 'react';
import { useSSRSelector } from '@/redux/ssrStore';

const SideFloatingButton = (props) => {
  const dispatch = useDispatch();
  const openForm = () => {
    dispatch(toggleFormWidget(true));
  };
  const [floatingButtonState, setFloatingButtonState] = useState(
    transformWidgetProps(props?.config?.enquiryForm?.config)
  );
  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));
  const { widgetData } = useSelector((state) => ({
    widgetData: state.widgetsReducer,
  }));
  const [propStyle, setPropStyle] = useState(storeData?.theme?.style_template);

  useEffect(() => {
    if (widgetData?.activeStyleTemplate) {
      setPropStyle(getStyleForProps(widgetData?.activeStyleTemplate));
    } else {
      setPropStyle(getStyleForProps(storeData?.theme?.style_template));
    }
  }, [widgetData?.activeStyleTemplate, storeData?.theme?.style_template]);

  useEffect(() => {
    setFloatingButtonState(transformWidgetProps(props?.config?.enquiryForm?.config));
  }, [props]);
  return floatingButtonState?.EnquiryForm?.config?.btnText?.length > 0 ? (
    <SideFloatingButtonWrapper
      themeConfig={propStyle}
      styleConfig={floatingButtonState?.EnquiryForm?.styleConfig?.alignment}
      onClick={() => openForm()}
      className={`${
        props?.inBuilder && props?.showPreview
          ? 'btn_side_floating_builder'
          : `btn_side_floating_preview_${props?.device}`
      } ${
        props?.inBuilder === false && props?.showPreview === undefined
          ? 'btn_side_floating_cfe'
          : ''
      }`}
    >
      {floatingButtonState?.EnquiryForm?.config?.btnText}
    </SideFloatingButtonWrapper>
  ) : (
    <></>
  );
};

export default SideFloatingButton;
